import { isValidNumber, isValidMaxNumber } from '../../../utils/validators';
import { ERangeErrorMessages } from '../constants';

export const validateGte = (gte: string, lte: string, required: boolean): string | null => {
  if (isValidNumber(gte) && !isValidMaxNumber(Number(gte))) {
    return ERangeErrorMessages.Max;
  }

  return (!gte && !required) || isValidNumber(gte) || isValidNumber(lte) ? null : ERangeErrorMessages.GteRequired;
};

export const validateLte = (gte: string, lte: string, required: boolean): string | null => {
  if (isValidNumber(gte) && isValidNumber(lte) && Number(lte) < Number(gte)) {
    return ERangeErrorMessages.GteLte;
  }

  if (isValidNumber(lte) && !isValidMaxNumber(Number(lte))) {
    return ERangeErrorMessages.Max;
  }

  return (!lte && !required) || isValidNumber(lte) || isValidNumber(gte) ? null : ERangeErrorMessages.LteRequired;
};
